// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.push-notification_9b489873 {
  position: fixed;
  display: flex;
  z-index: 90;
  transition: all 500ms ease;
}
.push-notification_bottom-left_9b489873 {
  left: 0.834rem;
  bottom: 0.834rem;
  flex-direction: column-reverse;
}
.push-notification_bottom-right_9b489873 {
  right: 0.834rem;
  bottom: 0.834rem;
  flex-direction: column-reverse;
}
.push-notification_top-left_9b489873 {
  top: 0.834rem;
  left: 0.834rem;
  flex-direction: column;
}
.push-notification_top-right_9b489873 {
  top: 0.834rem;
  right: 0.834rem;
  flex-direction: column;
}
.push-notification_bottom-left_9b489873.push-notification_slide_9b489873 .push-notification-item_9b489873,
.push-notification_top-left_9b489873.push-notification_slide_9b489873 .push-notification-item_9b489873 {
  align-items: flex-start;
}
.push-notification_bottom-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873,
.push-notification_top-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873 {
  transform: translateX(-110%);
}
.push-notification_bottom-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.exiting_9b489873,
.push-notification_top-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.exiting_9b489873 {
  transform: translateX(-110%);
}
.push-notification_bottom-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.entered_9b489873,
.push-notification_top-left_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.entered_9b489873 {
  transform: translateX(0);
}
.push-notification_bottom-left_9b489873.push-notification_fade_9b489873 .push-notification-item_9b489873,
.push-notification_top-left_9b489873.push-notification_fade_9b489873 .push-notification-item_9b489873 {
  align-items: flex-start;
}
.push-notification_bottom-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873,
.push-notification_top-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873 {
  opacity: 0;
}
.push-notification_bottom-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.exiting_9b489873,
.push-notification_top-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.exiting_9b489873 {
  opacity: 0;
}
.push-notification_bottom-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.entered_9b489873,
.push-notification_top-left_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.entered_9b489873 {
  opacity: 1;
}
.push-notification_top-right_9b489873.push-notification_slide_9b489873 .push-notification-item_9b489873,
.push-notification_bottom-right_9b489873.push-notification_slide_9b489873 .push-notification-item_9b489873 {
  align-items: flex-end;
}
.push-notification_top-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873,
.push-notification_bottom-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873 {
  transform: translateX(110%);
}
.push-notification_top-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.exiting_9b489873,
.push-notification_bottom-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.exiting_9b489873 {
  transform: translateX(110%);
}
.push-notification_top-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.entered_9b489873,
.push-notification_bottom-right_9b489873.push-notification_slide_9b489873 .push-notification-item__container_9b489873.entered_9b489873 {
  transform: translateX(0);
}
.push-notification_top-right_9b489873.push-notification_fade_9b489873 .push-notification-item_9b489873,
.push-notification_bottom-right_9b489873.push-notification_fade_9b489873 .push-notification-item_9b489873 {
  align-items: flex-end;
}
.push-notification_top-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873,
.push-notification_bottom-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873 {
  opacity: 0;
}
.push-notification_top-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.exiting_9b489873,
.push-notification_bottom-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.exiting_9b489873 {
  opacity: 0;
}
.push-notification_top-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.entered_9b489873,
.push-notification_bottom-right_9b489873.push-notification_fade_9b489873 .push-notification-item__container_9b489873.entered_9b489873 {
  opacity: 1;
}
.push-notification-item_9b489873 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: height 500ms 500ms ease;
}
.push-notification-item__content_9b489873 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.push-notification-item__content_9b489873 > :first-child {
  flex-grow: 1;
}
.push-notification-item__content_9b489873 > :nth-child(n+2) {
  margin-left: 2rem;
}
.push-notification-item__container_9b489873 {
  padding: 2rem;
  min-width: 20.834rem;
  max-width: 50rem;
  border: 0.084rem solid transparent;
  box-shadow: 0 0.334rem 0.334rem 0 rgba(0,0,0,0.24), 0 0 0.167rem 0 rgba(0,0,0,0.12);
  transition: all 500ms ease;
}
.push-notification-item__container_default_9b489873 {
  background-color: #dceffa;
  border-color: #26649e;
}
.push-notification-item__container_default_9b489873 .push-notification-item__icon_9b489873 {
  color: #26649e;
}
.push-notification-item__container_error_9b489873 {
  background-color: #fee0d0;
  border-color: #b32700;
  color: #b32700;
}
.push-notification-item__container_error_9b489873 .push-notification-item__icon_9b489873 {
  color: #b32700;
}
.push-notification-item__container_success_9b489873 {
  background-color: #e3f4f4;
  border-color: #267479;
}
.push-notification-item__container_success_9b489873 .push-notification-item__icon_9b489873 {
  color: #267479;
}
.push-notification-item__container_warning_9b489873 {
  background-color: #fef3db;
  border-color: #f5c914;
}
.push-notification-item__container_warning_9b489873 .push-notification-item__icon_9b489873 {
  color: #26649e;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"push-notification": `push-notification_9b489873`,
	"push-notification_bottom-left": `push-notification_bottom-left_9b489873`,
	"push-notification_bottom-right": `push-notification_bottom-right_9b489873`,
	"push-notification_top-left": `push-notification_top-left_9b489873`,
	"push-notification_top-right": `push-notification_top-right_9b489873`,
	"push-notification_slide": `push-notification_slide_9b489873`,
	"push-notification-item": `push-notification-item_9b489873`,
	"push-notification-item__container": `push-notification-item__container_9b489873`,
	"exiting": `exiting_9b489873`,
	"entered": `entered_9b489873`,
	"push-notification_fade": `push-notification_fade_9b489873`,
	"push-notification-item__content": `push-notification-item__content_9b489873`,
	"push-notification-item__container_default": `push-notification-item__container_default_9b489873`,
	"push-notification-item__icon": `push-notification-item__icon_9b489873`,
	"push-notification-item__container_error": `push-notification-item__container_error_9b489873`,
	"push-notification-item__container_success": `push-notification-item__container_success_9b489873`,
	"push-notification-item__container_warning": `push-notification-item__container_warning_9b489873`
};
export default ___CSS_LOADER_EXPORT___;
